import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const TEAM = [
    {
        initials: 'AK',
        name: 'Askar Kazhybay',
        role: 'Founder & CEO',
        bio: 'Built Interim to make earning money feel as simple as helping a neighbour. Believes the first paid hour changes everything.',
        accent: 'var(--teal-700)',
    },
];

const People = () => {
    const navigate = useNavigate();

    return (
        <div className="pe-page">
            <main>

                {/* Hero */}
                <section className="pe-hero">
                    <div className="ix-container">
                        <div className="pe-hero-eyebrow mono">The team</div>
                        <h1 className="pe-hero-title">
                            People who believe<br />
                            work should be <em>easy.</em>
                        </h1>
                        <p className="pe-hero-sub">
                            A small, focused team building tools for people who want to earn — and people who need things done.
                        </p>
                    </div>
                </section>

                {/* Team grid */}
                <section className="pe-team">
                    <div className="ix-container">
                        <div className="pe-grid">
                            {TEAM.map(person => (
                                <div key={person.name} className="pe-card">
                                    <div className="pe-card-avatar" style={{ background: person.accent }}>
                                        {person.initials}
                                    </div>
                                    <div className="pe-card-body">
                                        <div className="pe-card-role mono">{person.role}</div>
                                        <h2 className="pe-card-name">{person.name}</h2>
                                        <p className="pe-card-bio">{person.bio}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Join section */}
                <section className="pe-join">
                    <div className="ix-container">
                        <div className="pe-join-inner">
                            <div className="pe-join-text">
                                <span className="pe-eyebrow mono">We're growing</span>
                                <h2 className="pe-join-title">
                                    Want to help build<br />
                                    <em>the next version?</em>
                                </h2>
                                <p className="pe-join-sub">
                                    No open roles listed yet — but if you think you'd make Interim better, reach out directly.
                                </p>
                            </div>
                            <div className="pe-join-action">
                                <button
                                    className="ix-btn ix-btn-primary ix-btn-lg"
                                    onClick={() => navigate('/contact')}
                                    style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
                                >
                                    Get in touch <ArrowRight size={16} />
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
        </div>
    );
};

export default People;
